// src/pages/NestProject.jsx
import React, { useEffect } from 'react';
import Layout from '../components/layout/Layout';
import ProjectOverview from '../components/projects/ProjectOverview';
import ProjectFeatures from '../components/projects/ProjectFeatures';
import ProjectLocation from '../components/projects/ProjectLocation';
import ProjectGallery from '../components/projects/ProjectGallery';
import ProjectHero from '../components/projects/ProjectHero';
import InteractiveWalkthrough from '../components/projects/InteractiveWalkthrough';
import img1 from '../assets/exterior/vasudharinihomes_exterior_1.png'
import img2 from '../assets/exterior/vasudharinihomes_exterior_2.png'
import img3 from '../assets/exterior/vasudharinihomes_exterior_3.png'
import img4 from '../assets/interior/vasudharinihomes_interior_2.png'
import img5 from '../assets/interior/vasudharinihomes_interior_22.png'
import img6 from '../assets/exterior/vasudharinihomes_exterior_8.png'
import img7 from '../assets/exterior/vasudharinihomes_exterior_9.png'
import img8 from '../assets/exterior/vasudharinihomes_exterior_7.png'
import img9 from '../assets/interior/vasudharinihomes_interior_20.png'
import img10 from '../assets/interior/vasudharinihomes_interior_6.png'
import img11 from '../assets/interior/vasudharinihomes_interior_7.png'
import img12 from '../assets/interior/vasudharinihomes_interior_8.png'
import img13 from '../assets/interior/vasudharinihomes_interior_11.png'
import img14 from '../assets/interior/vasudharinihomes_interior_12.png'
import img15 from '../assets/interior/vasudharinihomes_interior_17.png'
import img16 from '../assets/interior/vasudharinihomes_interior_3.png'
import img17 from '../assets/interior/vasudharinihomes_interior_1.png'
import img18 from '../assets/exterior/vasudharinihomes_exterior_15.png'
import img19 from '../assets/exterior/vasudharinihomes_exterior_10.png'
import img20 from '../assets/exterior/vasudharinihomes_exterior_13.png'
import img21 from '../assets/exterior/vasudharinihomes_exterior_16.png'
import img22 from '../assets/exterior/vasudharinihomes_exterior_17.png'
import ProjectSpecifications from '../components/projects/ProjectSpecifications';
import FloorPlans from '../components/projects/FloorPlans';
import MasterPlan from '../components/projects/MasterPlan';

const NestProject = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

  // Sample data that would normally come from a CMS or API
  const projectData = {
    title: 'The Nest Eco-Housing Project',
    description: 'The Nest is a revolutionary eco-housing community that seamlessly integrates sustainable living with modern comfort. Located on the outskirts of Bangalore, this project consists of 24 homes arranged around shared green spaces, community gardens, and a central wellness area. Each home is designed to maximize natural light and ventilation while minimizing environmental impact through innovative use of materials and energy systems.',
    mainImage: img1,
    location: 'Bangalore, Karnataka',
    size: '5 acres, 24 homes',
    completionDate: 'March 2022',
    type: 'Residential Community',
  };

  const features = [
    {
      title: 'Passive Solar Design',
      description: 'Homes are oriented to maximize natural light and heat during winter while providing shade during summer.',
      icon: '☀️'
    },
    {
      title: 'Rainwater Harvesting',
      description: 'Comprehensive system captures rainwater for irrigation and non-potable household uses.',
      icon: '💧'
    },
    {
      title: 'Solar Power Generation',
      description: 'Rooftop solar panels generate approximately 80% of the community\'s electricity needs.',
      icon: '⚡'
    },
    {
      title: 'Natural Building Materials',
      description: 'Locally sourced stone, sustainably harvested timber, and compressed earth blocks reduce carbon footprint.',
      icon: '🧱'
    },
    {
      title: 'Community Gardens',
      description: 'Dedicated spaces for organic food production and native plant landscaping.',
      icon: '🌱'
    },
    {
      title: 'Smart Home Systems',
      description: 'Integrated technology for monitoring and optimizing energy and water usage.',
      icon: '🏠'
    }
  ];

  const locationData = {
    description: 'Located in Sarjapur, Bengaluru, Vasudharini Nest offers a seamless blend of modern living and natural tranquility. With futuristic developments like SWIFT City and the Bengaluru Metro Hebbal-Sarjapur Corridor (Phase 3A) planned in the area, the location promises excellent connectivity and investment potential.',
    address: 
      `Survey No 6/1 & 6/10 Kutaganahalli
       Handenahalli Panchayath,
       Sarjapura Hobli, Anekal Taluk,
       Bangalore Urban District,
       Pin Code: 562125.`,
    amenities: [
      'Educational Institutions – Top international schools and colleges',
      'IT Hubs & Business Parks – Close to major tech parks, making it ideal for professionals',
      'Healthcare Facilities – Leading hospitals and clinics within',
      'Shopping & Entertainment – Proximity to malls, supermarkets, and fine dining options',
      'Public Transport & Connectivity – Well-connected by roads with upcoming metro expansion',
      'Green Spaces & Recreation – Parks, sports complexes, and a peaceful suburban setting'
    ]
  };

  // const timeline = [
  //   {
  //     date: 'January 2020',
  //     title: 'Project Conception',
  //     description: 'Initial concept development and site selection'
  //   },
  //   {
  //     date: 'April 2020',
  //     title: 'Design Phase',
  //     description: 'Architectural planning and sustainable systems integration'
  //   },
  //   {
  //     date: 'August 2020',
  //     title: 'Permits & Approvals',
  //     description: 'Obtaining necessary permissions and environmental clearances'
  //   },
  //   {
  //     date: 'November 2020',
  //     title: 'Construction Begins',
  //     description: 'Groundbreaking and foundation work'
  //   },
  //   {
  //     date: 'September 2021',
  //     title: 'Core Construction Complete',
  //     description: 'Structural elements and major systems installed'
  //   },
  //   {
  //     date: 'February 2022',
  //     title: 'Finishing & Landscaping',
  //     description: 'Interior finishes and ecosystem restoration'
  //   },
  //   {
  //     date: 'March 2022',
  //     title: 'Project Completion',
  //     description: 'Final inspections and resident move-in'
  //   }
  // ];

  const galleryImages = [
    {
      url: img1,
      alt: 'Exterior view of The Nest homes'
    },
    {
      url: img21,
      alt: 'Community amenities and gardens'
    },
    {
      url: img2,
      alt: 'Sustainable interior design'
    },
    {
      url: img22,
      alt: 'Sustainable interior design'
    },
    {
      url: img3,
      alt: 'Community amenities and gardens'
    },
    {
      url: img4,
      alt: 'Sustainable construction techniques'
    },
    {
      url: img5,    
      alt: 'Solar panel installation'
    },
    {
      url: img6,    
      alt: 'Rainwater harvesting system'
    },
    {
      url: img7,    
      alt: 'Rainwater harvesting system'
    },
    {
      url: img8,    
      alt: 'Rainwater harvesting system'
    },
    {
      url: img9,    
      alt: 'Rainwater harvesting system'
    },
    {
      url: img10,    
      alt: 'Rainwater harvesting system'
    },
    {
      url: img11,    
      alt: 'Rainwater harvesting system'
    },
    {
      url: img12,    
      alt: 'Rainwater harvesting system'
    },
    {
      url: img13,    
      alt: 'Rainwater harvesting system'
    },
    {
      url: img14,    
      alt: 'Rainwater harvesting system'
    },
    {
      url: img15,    
      alt: 'Rainwater harvesting system'
    },
    {
      url: img16,    
      alt: 'Rainwater harvesting system'
    },
    {
      url: img17,    
      alt: 'Rainwater harvesting system'
    },
    {
      url: img18,    
      alt: 'Rainwater harvesting system'
    },
    {
      url: img19,    
      alt: 'Rainwater harvesting system'
    },
    {
      url: img20,    
      alt: 'Rainwater harvesting system'
    },
  ];

  const galleryVideos = [
    {
      title: 'Project Walkthrough',
      url: 'https://www.youtube.com/embed/sWlPS2pSuys?rel=0'
    },
    {
      title: 'Construction Progress',
      url: 'https://www.youtube.com/embed/rIkbIIVBcTI?rel=0'
    },
    {
      title: 'Construction Update',
      url: 'https://www.youtube.com/embed/IAxuUcqOnUk?rel=0'
    },
  ];


  return (
    <Layout>
      {/* <Section className="bg-gray-50 py-16">
        <div className="container mx-auto px-4">
          <Heading level="h1">The Nest Eco-Housing Project</Heading>
          <p className="text-xl text-gray-600 mt-4 max-w-3xl">
            A sustainable community where modern living harmonizes with nature.
          </p>
        </div>
      </Section> */}
      
      <ProjectHero />
      <ProjectOverview project={projectData} />
      <InteractiveWalkthrough />
      <ProjectFeatures features={features} />
      <ProjectSpecifications />
      <ProjectGallery images={galleryImages} videos={galleryVideos} />
      <MasterPlan />

      <FloorPlans />
      <ProjectLocation location={locationData} />
    </Layout>
  );
};

export default NestProject;